import { Box, makeStyles, Link } from '@material-ui/core';
import SmallFooter from 'features/utilisateurs/components/Footer';
import SmallHeader from 'features/utilisateurs/components/header';
import secure from '../../assets/secure.svg';
import classNames from 'classnames';
import SGSMessageBox from 'components/SGSMessageBox';

const UpdatePassword = () => {
    const classes = useStyles();
    return (
        <>
            <Box className={classes.container}>
                <SmallHeader />
                <SGSMessageBox Message={Message} />
                <SmallFooter />
            </Box>
        </>
    );
};

export default UpdatePassword;

const Message = ({ classes }) => {
    return (
        <>
            <Box className={classes.boxTitle}>NOUVEAU Système de sécurité !</Box>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} className="mt-3 mb-2">
                <img src={secure} alt={''} />
            </Box>

            <Box className={classes.titre}>Mettez à jour votre mot de passe</Box>
            <Box className={'m-5'}>
                <Box className={classes.txt}>
                    Nous avons renforcé les mesures de sécurité pour protéger vos informations personnelles. <br />
                    En raison des évolutions de notre système, nous vous invitons à mettre à jour votre mot de passe :
                </Box>
                <Box className="mt-1">
                    <Box display={'flex'} flexDirection={'row'} className="mt-4" alignItems={'center'}>
                        <Box className={classes.pill}>1</Box>
                        <Box className={classes.pillText}>Sur l’email du compte associé à votre profil, cliquez sur le lien de réinitialisation de mot de passe</Box>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} className="mt-2" alignItems={'center'}>
                        <Box className={classes.pill}>2</Box>
                        <Box className={classes.pillText}>Suivez les instructions pour définir un nouveau mot de passe sécurisé</Box>
                    </Box>
                    <Box className={classes.txt}>Le lien associé au mail est valable pendant 15 minutes. Pensez à vérifier vos spams s’il n’est pas dans votre boite de réception.</Box>
                    <Box className={classes.txt}>
                        Si vous avez des questions ou avez besoin d’aide supplémentaire, n’hésitez pas à nous contacter à l'adresse{' '}
                        <Link href="mailto:support@sgsante.fr" className={classes.emailLink}>
                            support@sgsante.fr
                        </Link>
                        .
                        <br />
                        <Box className={classes.txt}>Merci pour votre compréhension.</Box>
                        <Box className={classNames(classes.txt, 'mt-3')}>
                            <Box>Bien cordialement,</Box>
                            <Box className={classes.txtBold}>L’équipe SG Santé</Box>
                        </Box>
                        <Box className={classes.mb20}></Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
    },
    row: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #ccc',
    },
    middleRow: {
        flex: 2,
    },
    titre: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#2574A9',
        fontFamily: 'Open Sans',
        fontSize: 22,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        textAlign: 'center',
        paddingTop: '20px',
    },

    sousTitre: {
        color: '#2574A9',
        fontFamily: 'Open Sans',
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: 600,
        marginTop: '10px',
        lineHeight: 'normal',
    },

    txt: {
        color: '#4F7793',
        fontFamily: 'Open Sans',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '26px',
        fontWeight: 400,
        marginTop: '30px',
    },

    box: {
        borderRadius: '10px',
        background: '#FFF',
        boxShadow: '0px 0px 50px 0px rgba(37, 116, 169, 0.15)',
        maxWidth: '980px',
        margin: 'auto',
    },

    boxTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '26px' /* 144.444% */,
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        borderBottom: '1px solid #ECECEC',
        background: '#2574A9',
        height: '94px',
    },
}));
